module.exports = __webpack_public_path__ + "media/images/honeycomb-04d9a366a689023303b746b06d796f2b.svg";